// Theme toggle — top-right, drives the follow-system switch in useTheme
// (per ADR-0009). Cycles System → Light → Dark → System. The glyph reflects
// the scheme currently showing; the title spells out the active preference so
// "follow system" is never a mystery.

import { IconJD } from './atoms';
import { useTheme, type ThemePreference } from '../../hooks/useTheme';

const ORDER: ThemePreference[] = ['system', 'light', 'dark'];

const LABEL: Record<ThemePreference, string> = {
  system: 'Theme: follow system',
  light: 'Theme: light',
  dark: 'Theme: dark',
};

export function ThemeToggle() {
  const { preference, scheme, setPreference } = useTheme();

  const next = () => {
    const i = ORDER.indexOf(preference);
    setPreference(ORDER[(i + 1) % ORDER.length]);
  };

  return (
    <button type="button" className="jd-icon-btn" onClick={next} title={LABEL[preference]} aria-label={LABEL[preference]}>
      {preference === 'system' ? (
        <IconJD name="settings" size={16} stroke={1.7} color="currentColor" />
      ) : scheme === 'dark' ? (
        <MoonGlyph />
      ) : (
        <SunGlyph />
      )}
    </button>
  );
}

function SunGlyph() {
  return (
    <svg
      width={16}
      height={16}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.7}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="12" cy="12" r="4" />
      <path d="M12 2v2M12 20v2M2 12h2M20 12h2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4" />
    </svg>
  );
}

function MoonGlyph() {
  return (
    <svg
      width={16}
      height={16}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.7}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8z" />
    </svg>
  );
}
